@use 'src/globals/main';

pn-progress-indicator-step {
  display: flex;
  flex: 1 0 4em;

  &:first-child {
    flex: 0 0 auto;

    .progress-line {
      display: none;
    }

    .info-container {
      transform: translateX(-50%);
      left: 50%;
    }
  }
}

.pn-progress-indicator-step {
  position: relative;
  display: flex;
  flex: 1 0 4em;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;

  .circle {
    width: 1.5em;
    height: 1.5em;
    padding: 0.3rem;
    border-radius: 50%;
    background-color: main.$gray50;
    @include main.pn-transition('background-color');
  }

  .info-container {
    position: absolute;
    bottom: -2.5em;
    right: 0;
    transform: translateX(50%) translateX(-1.2rem);
    white-space: nowrap;
    color: main.$gray50;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 1em;
    font-weight: normal;
    @include main.pn-transition('color');

    .pn-icon-svg {
      height: 1.7em;
      width: 1.7em;
      margin-bottom: 0.1em;
    }

    .pn-icon-svg path,
    .pn-icon-svg polygon {
      fill: main.$gray50;
    }
  }

  .progress-line {
    flex: 1 1 auto;
    margin: auto 4px;
    height: 0.8rem;
    background-color: main.$gray50;
    position: relative;
    overflow: hidden;
    pointer-events: none;
    border-radius: 10rem;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 0.8rem;
      width: 100%;
      background-color: main.$blue700;
      transform: translateX(-100%);
      @include main.pn-transition('transform');
      transition-delay: main.$timing;
    }
  }

  &.active {
    .info-container {
      color: main.$black;

      .pn-icon-svg path {
        fill: main.$black;
      }

      .pn-icon-svg polygon {
        fill: main.$black;
      }
    }
  }

  &.activated {
    cursor: pointer;
  }

  &.done,
  &.active {
    .progress-line:after {
      transform: translateX(0);
    }

    .circle {
      background-color: main.$blue700;
    }
  }

  &.done {
    .checkmark-path {
      stroke-linecap: round;
      stroke-dasharray: 27;
      stroke-dashoffset: -23;
      animation: dash main.$timing cubic-bezier(0.55, 0, 0.1, 1) both;
    }
  }
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
